import api from '@/api/aiChatbot'

const state = {
  aiChatbotVisitorMap: {}
}

const actions = {
  getAiChatbotConfig () {
    return api.getAiChatbotConfig()
  },
  updateAiChatbotConfig (context, data) {
    return api.updateAiChatbotConfig(data)
  },
  getPublicAiChatbotConfig (context, params) {
    return api.getPublicAiChatbotConfig(params)
  },
  async getPublicAiChatbotWelcomeTrigger (context, params) {
    const resp = await api.getPublicAiChatbotWelcomeTrigger(params)
    const companyId = params.company_id
    const visitorId = resp.visitor_id
    if (resp.available !== false) {
      context.commit('SET_AI_CHATBOT_VISITOR', { visitorId, companyId })
    }
    return resp
  },
  getPublicAiChatbotWelcomeBackTrigger (context, params) {
    return api.getPublicAiChatbotWelcomeBackTrigger(params)
  },
  getPublicAiChatbotStay30sTrigger (context, params) {
    return api.getPublicAiChatbotStay30sTrigger(params)
  }
}

const mutations = {
  SET_AI_CHATBOT_VISITOR: (state, { visitorId, companyId }) => {
    state.aiChatbotVisitorMap = {
      ...state.aiChatbotVisitorMap,
      [companyId]: visitorId
    }
  }
}

const getters = {
  aiChatbotVisitorMap: (state) => {
    return state.aiChatbotVisitorMap
  }
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
